import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  FaUser, FaEnvelope, FaPhone, FaComment,
  FaCheck, FaPaperPlane, FaSpinner, FaExclamationCircle 
} from 'react-icons/fa';
import '../../../assets/css/orcamentoPiano.css';

const partsOptions = [
  { id: 'geral', name: 'Reforma Geral', image: '/img/orcamento/piano_geral.jpg' },
  { id: 'movel', name: 'Móvel', image: '/img/orcamento/piano_movel.jpg' },
  { id: 'mecanismo', name: 'Mecanismo', image: '/img/orcamento/piano_mecanismo.jpg' },
  { id: 'encordamento', name: 'Encordamento', image: '/img/orcamento/piano_encordamento.jpg' }
];

const OrcamentoPiano = () => {
  const [selectedParts, setSelectedParts] = useState([]);
  const [activeOverlay, setActiveOverlay] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  // Novos estados para controlar o envio do formulário
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error' ou null

  const togglePartSelection = (part) => {
    setSelectedParts(prev => {
      if (prev.some(p => p.id === part.id)) {
        if (part.id === 'geral') {
          return prev.filter(p => p.id !== 'geral');
        }
        return prev.filter(p => p.id !== part.id);
      } else {
        if (part.id === 'geral') {
          return [part];
        }
        return [...prev.filter(p => p.id !== 'geral'), part];
      }
    });
    
    setActiveOverlay(part.id);
    setTimeout(() => setActiveOverlay(null), 1000);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Função de envio atualizada
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedParts.length === 0) {
      alert('Por favor, selecione pelo menos um serviço.');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    // Combina os dados do formulário e as partes selecionadas
    const payload = { ...formData, selectedParts };

    try {
      // SUBSTITUA PELA URL CORRETA DO SEU SCRIPT PHP
      const response = await fetch('https://pianoswaldir.com.br/api/enviar_orcamento.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        setSubmitStatus('success');
        // Limpa o formulário após o sucesso
        setFormData({ name: '', email: '', phone: '', message: '' });
        setSelectedParts([]);
      } else {
        // Erro retornado pelo script PHP (ex: validação)
        console.error('Erro do servidor:', result.message);
        setSubmitStatus('error');
      }
    } catch (error) {
      // Erro de rede ou falha na comunicação
      console.error('Erro de rede:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="orcamento-container">
         
      <motion.div 
      
        className="piano-section"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
      >

        <div className='piano-coluna'>


        <div className="piano-image-container-ocp">
          {/* Imagem base do piano */}
 <img 
  src="/img/orcamento/piano.jpg" 
  alt="Piano" 
  className="base-piano-image" 
/>
          
          {/* Overlays para cada parte */}
          {partsOptions.map(part => (
            <img
              key={part.id}
              src={part.image}
              alt={`Parte ${part.name}`}
              className={`piano-overlay ${activeOverlay === part.id ? 'active' : ''}`}
            />
          ))}

          
          

        </div>

                   <div className="orcamento-header">
          <h2 className="orcamento-title">Orçamento Personalizado</h2>
          <p className="orcamento-subtitle">Selecione os serviços necessários para seu piano</p>
        </div>

         {/* Áreas clicáveis para seleção */}
          <div className="part-selector">
            <div 
              className={`part-option ${selectedParts.some(p => p.id === 'geral') ? 'selected' : ''}`}
              onClick={() => togglePartSelection(partsOptions[0])}
              
            >
              Reforma Geral
            </div>
            <div 
              className={`part-option ${selectedParts.some(p => p.id === 'movel') ? 'selected' : ''}`}
              onClick={() => togglePartSelection(partsOptions[1])}
            >
              Móvel
            </div>
            <div 
              className={`part-option ${selectedParts.some(p => p.id === 'mecanismo') ? 'selected' : ''}`}
              onClick={() => togglePartSelection(partsOptions[2])}
            >
              Mecanismo
            </div>
            <div 
              className={`part-option ${selectedParts.some(p => p.id === 'encordamento') ? 'selected' : ''}`}
              onClick={() => togglePartSelection(partsOptions[3])}
            >
              Encordamento
            </div>
          </div>

                 </div>

        
      </motion.div>
      <motion.div 
        className="form-section"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        {/* Partes selecionadas */}
        {selectedParts.length > 0 && (
          <motion.div 
            className="selected-parts animate-fade-in"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <h3 className="selected-parts-title">
              <FaCheck /> Serviços selecionados
            </h3>
            <div className="selected-parts-list">
              {selectedParts.map(part => (
                <span key={part.id} className="selected-part-tag">
                  {part.name}
                </span>
              ))}
            </div>
          </motion.div>
        )}
        
        {/* Formulário */}
        <form className="orcamento-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="name" className="form-label">Nome</label>
            <div className="input-wrapper">
              <FaUser className="input-icon" />
              <input
                type="text"
                id="name"
                name="name"
                className="form-input"
                placeholder="Seu nome completo"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          
          <div className="input-group">
            <label htmlFor="email" className="form-label">E-mail</label>
            <div className="input-wrapper">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                id="email"
                name="email"
                className="form-input"
                placeholder="seu@email.com"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          
          <div className="input-group">
            <label htmlFor="phone" className="form-label">WhatsApp/Celular</label>
            <div className="input-wrapper">
              <FaPhone className="input-icon" />
              <input
                type="tel"
                id="phone"
                name="phone"
                className="form-input"
                placeholder="(00) 00000-0000"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          
          <div className="input-group">
            <label htmlFor="message" className="form-label">Mensagem</label>
            <div className="input-wrapper">
              <FaComment className="input-icon" style={{ top: '2.8rem' }} />
              <textarea
                id="message"
                name="message"
                className="form-input form-textarea"
                placeholder="Descreva o serviço necessário..."
                value={formData.message}
                onChange={handleInputChange}
              />
            </div>
          </div>
          
          <motion.button
            type="submit"
            className="submit-button"
            disabled={isSubmitting} // Desabilita o botão durante o envio
            whileHover={{ scale: isSubmitting ? 1 : 1.02 }}
            whileTap={{ scale: isSubmitting ? 1 : 0.98 }}
          >
            {isSubmitting ? (
              <><FaSpinner className="spin-icon" /> Enviando...</>
            ) : (
              <><FaPaperPlane /> Solicitar Orçamento</>
            )}
          </motion.button>
          
          {/* Mensagens de feedback */}
          {submitStatus === 'success' && (
            <div className="feedback-message success">
              <FaCheck /> Orçamento enviado com sucesso!
            </div>
          )}
          {submitStatus === 'error' && (
            <div className="feedback-message error">
              <FaExclamationCircle /> Falha ao enviar. Tente novamente.
            </div>
          )}
        </form>
      </motion.div>
    </div>
  );
};

export default OrcamentoPiano;